import ChangePasswordModule from "@/modules/ChangePassword";

function ChangePasswordPage() {
  return <ChangePasswordModule />;
}

export default ChangePasswordPage;
